import { Injectable } from "@angular/core";

declare var window;

@Injectable({
	providedIn: "root",
})
export class GoogleAdManagerService {
	eventsAdded = false;
	initialResize = window.innerWidth;


	constructor() {
		window['loadAdXAds'] = this.loadAdXAds.bind(this);
		window['validateEnv'] = this.validateEnv.bind(this);
		window['browserResize'] = this.browserResize.bind(this);
	}

	initGoogleAdManager() {
		let that = this;
		window.googletag = window.googletag || { cmd: [] };

		window.googletag.cmd.push(function () {
			window.googletag.pubads().setPrivacySettings({
				restrictDataProcessing: true,
				limitedAds: !that.getCookieValue()
			});
			window.googletag.enableServices();
		});

		if (window.addEventListener) {
			window.addEventListener("resize", window.browserResize);
		} else if (window.attachEvent) {
			window.attachEvent("onresize", window.browserResize);
		}
	}

	browserResize() {
		let afterResize = window.innerWidth;
		if (
			(this.initialResize < 1440 && afterResize >= 1440) ||
			(this.initialResize >= 1440 && afterResize < 1440) ||
			(this.initialResize < 1024 && afterResize >= 1024) ||
			(this.initialResize >= 1024 && afterResize < 1024) ||
			(this.initialResize < 768 && afterResize >= 768) ||
			(this.initialResize >= 768 && afterResize < 768) ||
			(this.initialResize < 360 && afterResize >= 360) ||
			(this.initialResize >= 360 && afterResize < 360)
		) {
			this.initialResize = afterResize;
			const filteredSlots = window.googletag.pubads()
				.getSlots()
				.filter((item) => item.getSizes().length > 1);

			for (let i = 0; i < filteredSlots.length; i++) {
				window.googletag.cmd.push(function () {
					window.googletag.pubads().refresh([filteredSlots[i]], {
						changeCorrelator: false,
					});
				});
			}
		}
	}

	validateEnv(adUnitPath, sizes) {
		const regex = /(nonprod)/;
		const str = adUnitPath.match(regex);
		if (str && str.length > 0 && sizes.length > 1 || str && str.length > 0 && sizes[0] != "fluid") {
			return true;
		} else {
			return false;
		}
	}

	// Function to add content to page
	slotGenerator(data: any, elem: string) {
		window.googletag.cmd.push(function () {
			var slot = window.validateEnv(data.adUnitPath, data.sizes) ?
				window.googletag.defineSlot(data.adUnitPath, data.sizes, elem)
					.set("adsense_test_mode", "on")
					.addService(window.googletag.pubads()) :
				window.googletag.defineSlot(data.adUnitPath, data.sizes, elem)
					.addService(window.googletag.pubads());

			if (data.sizeMapping) {
				slot.defineSizeMapping(data.sizeMapping);
			}

			if (data.targeting) {
				data.targeting.forEach((obj) => {
					const key = Object.keys(obj)[0]; //gets key value
					slot.setTargeting(key, obj[key]);
				});
			}
			window.googletag.display(slot);
			if(!this.eventsAdded) {
				window.googletag.pubads().addEventListener("slotResponseReceived", function (e) {
					if (e.slot.getAdUnitPath().includes('bottomb1') && e.slot.getResponseInformation()) {
						// Add horizontal bar as non endemic AD is loaded
						document.getElementById('rewardsAdBottom').className += 'googleAd-border d-flex justify-content-center';
					}
				});

				window.googletag.pubads().addEventListener("slotOnload", function(e) {
					const getDivId = document.getElementById("google_ads_iframe_" + e.slot.getSlotId().getId());
					getDivId.setAttribute('role', 'none');
				});

				this.eventsAdded = true;
			}
		});
	}

	loadAdXAds(adConfig) {
		this.slotGenerator(adConfig, "rewardsAdBottom");
	}

	gamScriptLoaded(isloaded, banner) {
		window.checkAdBlocker = true;
		if (!isloaded) { //adblocker is enabled
			window.googletag._loaded_ = false; 
			this.deleteGAMCookies(banner);
		}else{
			this.checkCookieConsentAndSetGAMoptions(banner);
		}
		window.dispatchEvent(new CustomEvent('adBlockerLoadChecked', { detail: { adblockerEnabled: isloaded } }));
	}

	checkCookieConsentAndSetGAMoptions(banner) {
		const oneTrustLoadedEvent = window['dataLayer'] && window['dataLayer'].find(x => x.event === 'OneTrustGroupsUpdated');
		if (oneTrustLoadedEvent) {

			if (oneTrustLoadedEvent?.['OnetrustActiveGroups'].includes('C0004')) {
				this.setLimitedAdsOption(false);
			}
			else {
				this.setLimitedAdsOption(true);
				this.deleteGAMCookies(banner);
			}
		}
		else {
			// OneTrustLoaded event not fired yet - listen & then check if C003 part
			window.addEventListener("OneTrustGroupsUpdated", (eventResponse) => {
				const oneTrustLoadedEventResponse = eventResponse && eventResponse['detail'];
				if (oneTrustLoadedEventResponse && oneTrustLoadedEventResponse.includes('C0004')) {
					this.setLimitedAdsOption(false);

				} else {
					this.setLimitedAdsOption(true);
					this.deleteGAMCookies(banner);
				}
			}, { once: true });
		}
	}

	//update limitedAds option value
    public setLimitedAdsOption (value) {
        window['googletag'].cmd.push(function () {
            window['googletag'].pubads().setPrivacySettings({
                limitedAds: value
            });
        });
    }

    deleteGAMCookies = function (banner) {
        const GAMcookies = ["__gads", "__gpi", "__gpi_optout", "GED_PLAYLIST_ACTIVITY"];
        // "NID", "AEC", "1P_JAR", "IDE", "APC", "test_cookie", "DSID", "id" - these are 3rd party GAM related cookies, set on different domain (google, googlesyndication, doubleclick.net) and will not be populated once limitedAds is set to true.
        for (let cookieName of GAMcookies) {
            document.cookie = cookieName + `=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/; domain=.${banner}.com`;
        }
    }


	// check for targeting cookie value in OptanonConsent cookie
	getCookieValue(){
		const cookieValueOptanonConsent = document.cookie.split("; ").find((row) => row.startsWith("OptanonConsent="))?.split("=");
		let cookieValueOptanonConsentValue: any = 0;
		if (cookieValueOptanonConsent) {
			const index = cookieValueOptanonConsent.findIndex(value => value.includes("C0004"));
			if (index !== -1) {
				cookieValueOptanonConsentValue = decodeURIComponent(cookieValueOptanonConsent[index]).split(',')[2][6];
			}
		}
		return !cookieValueOptanonConsent || cookieValueOptanonConsentValue == 1
	}
}
